import script from "./index-web.vue?vue&type=script&lang=ts&setup=true"
export * from "./index-web.vue?vue&type=script&lang=ts&setup=true"

import "./style/index.scss?vue&type=style&index=0&id=47efc8af&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47efc8af"]])

export default __exports__